export const promptStringKeys: string[] = [
  'ADMIN_LABEL_CANCEL_SUBSCRIPTION_CONFIRMATION',
  'ADMIN_LABEL_CANCEL_SUBSCRIPTION_CONFIRMATION_IMMEDIATE',
  'REMOVE_PAYMENT_METHOD_CONFIRM',
  'REMOVE_PAYMENT_METHOD_ERROR',
];
